import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse, PagedResult } from '../models/product.models';
import { CreateReturnRequest, ReturnDto } from '../models/return.models';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class ReturnService extends ApiService {
  private readonly endpoint = `${environment.apiUrl}/api/Returns`;

  getReturns(
    page: number,
    pageSize: number,
    storeId?: string,
  ): Observable<ApiResponse<PagedResult<ReturnDto>>> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (storeId) params = params.set('storeId', storeId);
    return this.http.get<ApiResponse<PagedResult<ReturnDto>>>(this.endpoint, { params });
  }

  create(request: CreateReturnRequest): Observable<ApiResponse<{ returnId: string }>> {
    return this.http.post<ApiResponse<{ returnId: string }>>(this.endpoint, request);
  }
}
